import MessageTextAreaComponent from "./MessageTextAreaComponent";

export default MessageTextAreaComponent;
